<template>
  <div class="prop-container">
    <!-- 特有属性 -->
    <template v-if="ComponentProps[activeName] !== undefined">
      <strong> {{ ComponentProps[activeName].name }} </strong>
      <div class="prop-item" v-for="(item, key) in ComponentProps[activeName].values">
        <div class="label">
          <span>{{ item.label }}</span>

          <span v-if="item.desc">
            <el-tooltip :content="item.desc" placement="top">
              <i class="el-icon-question desc"></i>
            </el-tooltip>
          </span>
        </div>
        <div class="input-info">
          <!-- 字符串 -->
          <el-input v-model="item.value" size="mini" v-if="item.type === propsTypes.string" placeholder="请输入内容"
            @change="updateComponentProp"></el-input>
          <!-- JSON -->
          <el-button v-if="item.type === propsTypes.json" size="mini"
            @click="openCode(jsonData[key], key)">...</el-button>

          <!-- <textarea
            id="codejson"
            cols="30"
            rows="10"
            v-model="jsonData[key]"
            v-if="item.type === propsTypes.json"
            @blur="setJson(key)"
          ></textarea> -->

          <!-- <el-input
            v-model="jsonData[key]"
            type="textarea"
            rows="5"
            v-if="item.type === propsTypes.json"
            placeholder="[]"
            @change="setJson(key)"
          ></el-input> -->
          <!-- 数字 -->
          <el-input v-model="item.value" size="mini" type="number" v-if="item.type === propsTypes.number"
            placeholder="请输入内容" @change="updateComponentProp"></el-input>
          <!-- 开关 -->
          <el-switch v-if="item.type === propsTypes.switch" v-model="item.value" active-color="#13ce66"
            inactive-color="#ff4949" @change="updateComponentProp">
          </el-switch>

          <!-- 颜色 -->
          <el-color-picker v-model="item.value" size="mini" :show-alpha="true" v-if="item.type === propsTypes.color"
            :popper-class="'popper-color-prop'" @change="updateComponentProp"></el-color-picker>

          <!-- 枚举 -->
          <el-select v-model="item.value" size="mini" placeholder="请选择" v-if="item.type === propsTypes.eumn"
            @change="updateComponentProp">
            <el-option v-for="item1 in item.options" :key="item1.value || item" :label="item1.label || item"
              :value="item1.value || item">
            </el-option>
          </el-select>


        </div>
      </div>
    </template>

    <!-- 通用属性 -->
    <div v-for="(item, key) in props" :key="key">
      <strong> {{ key }} </strong>

      <template v-for="(item2, key2) in item">
        <div v-if="key2 !== 'category'" :key="key2" class="prop-item">
          <div class="label">
            <span>{{ item2.label }}</span>
            <span v-if="item2.desc">
              <el-tooltip :content="item2.desc" placement="top">
                <i class="el-icon-question desc"></i>
              </el-tooltip>
            </span>
          </div>
          <div class="input-info">
            <!-- 字符串 -->
            <el-input v-model="item2.value" size="mini" v-if="item2.type === propsTypes.string" placeholder="请输入内容"
              @change="updateProp"></el-input>
            <!-- 字符 -->
            <el-input-number v-if="item2.type === propsTypes.number" v-model="item2.value" controls-position="right"
              @change="updateProp" size="mini"></el-input-number>
            <!-- 颜色 -->
            <el-color-picker v-model="item2.value" size="mini" :show-alpha="true" v-if="item2.type === propsTypes.color"
              :popper-class="'popper-color-prop'" @change="updateProp"></el-color-picker>

            <!-- 枚举 -->
            <el-select v-model="item2.value" size="mini" v-if="item2.type === propsTypes.eumn" placeholder="请选择"
              @change="updateProp">
              <el-option v-for="selectitem in item2.options" :key="selectitem.value" :label="selectitem.label"
                :value="selectitem.value">
              </el-option>
            </el-select>
            <!-- switch -->
            <el-switch v-if="item2.type === propsTypes.switch" v-model="item2.value" active-color="#13ce66"
              inactive-color="#ff4949" @change="updateProp">
            </el-switch>
            <!-- {{ item2.value }} -->

            <el-button v-if="item2.type === propsTypes.json" size="mini"
            @click="openCode(jsonData[key], key)">...</el-button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Core from "@/libs/src/core";
import _propdata from "../types/prop";
import { propsTypes } from "../types/sprite-types";
import { ComponentProps } from "../types/component-prop";

export default {
  name: "prop-component",
  data() {
    return {
      props: {},
      propsTypes: propsTypes,
      activeName: "",
      ComponentProps: {},
      jsonData: {},
    };
  },

  created() {
    this.topo = Core.getProvider("TechnologyTopo");
    this.init();
  },

  methods: {
    init() {
      if (this.topo.store && this.topo.store.active.length == 1) {
        this.bindData(this.topo.store.active[0]);
      } else {
        this.props = {};
      }
      this.active = this.topo.store ? this.topo.store.active : [];
      this.activeName = this.active[0].name;
    },
    // 打开代码编辑器
    openCode(code, key) {
      this.$Application.run("code-editor", {
        style: {
          zIndex: 9999,
        },
      });
      // 初始化代码编辑器
      this.$Application.broadcast("codeText.init", code);
      // 接收代码编辑器的数据
      this.$Application.onmessage("codeText", (code) => {
        let data = code.data;
        this.jsonData[key] = data;
        this.setJson(key);
      });
    },
    // 设置json格式数据
    setJson(key) {
      let active = this.active[0];
      try {
        this.topo.stageCanvas.setValue({
          id: active.id,
          [key]: JSON.parse(this.jsonData[key]),
        });
      } catch (error) {
        this.$alert("格式错误：" + error);
      }
    },
    // 绑定数据
    bindData(active) {
      // 绑定通用属性
      let props = {};
      const propdata = JSON.parse(JSON.stringify(_propdata));
      for (let i = 0, len = propdata.length; i < len; i++) {
        if (!props[propdata[i].category]) {
          props[propdata[i].category] = {};
        }
        Object.keys(propdata[i]).forEach((k) => {
          if (active[k]) {
            propdata[i][k].value = active[k];
          }
          props[propdata[i].category][k] = propdata[i][k];
        });
      }

      this.props = Object.assign({}, this.props, props);

      // 绑定专用属性
      const componentsPropsData = JSON.parse(JSON.stringify(ComponentProps));
      let name = active["name"];
      // 通过属性名和哦去专用的属性列表
      let penProp = componentsPropsData[name];
      if (penProp && penProp.values) {
        Object.keys(penProp.values).forEach((key) => {
          if (active[key]) {
            penProp.values[key].value = active[key];
          }
          // 属性值为json格式
          if (penProp.values[key].type == propsTypes.json) {
            this.jsonData[key] = JSON.stringify(penProp.values[key].value);
          }
        });
        this.ComponentProps = componentsPropsData;
      }
    },
    //更新属性
    updateProp() {
      if (this.active.length === 1) {
        const setActiveVal = (key, val) => {
          if (this.active[0][key] !== val.value) {
            this.topo.stageCanvas._setValue({
              id: this.active[0].id,
              [key]: val.value,
            });
          }
        };
        Object.keys(this.props).forEach((k) => {
          Object.keys(this.props[k]).forEach((k2) => {
            setActiveVal(k2, this.props[k][k2]);
          });
        });
        this.topo.stageCanvas.render();
      }
    },

    // 特定属性更新
    updateComponentProp() {
      if (this.active.length === 1) {
        let active = this.active[0];
        // 设置通用属性
        let values = this.ComponentProps[this.activeName].values || {};

        Object.keys(values).forEach((key) => {
          if (active[key] !== values[key].value) {
            this.topo.stageCanvas._setValue({
              id: active.id,
              [key]: values[key].value,
            });
          }
        });

        this.topo.stageCanvas.render();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.prop-container {
  height: calc(100vh - 170px);
  overflow-y: auto;
}

.desc {
  cursor: pointer;
  margin-left: 5px;
}

.prop-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #515151;

  .label {
    width: 120px;
    text-align: right;
    padding-right: 10px;
  }

  .input-info {}
}
</style>